/* 紫微斗數 Chinese Astrology Zi Wei Dou Shu — HORIZONTAL STAR LABELS
   Notes:
   - StarA, StarB, StarC are rendered as single horizontal lines.
   - StarA/Star6 "mark" (the 4th character) is appended with a full-width space
     and colored #8000FF.
   - Keep your CSS alignment rules; if needed, add:
       .zwStarLeft  { text-align: left !important; }
       .zwStarRight { text-align: right !important; }
*/

var ziweiUI = {
  // 主星列印方向 true:由右向左,false:由左向右
  right2left: false,

  // UI resize
  resize: function () {
    // var wdth=$(window).width();
    // $("#divZiWei").css("left",wdth>640?(wdth-640)/2:0);
  },

  genNowDateZiwei: function () {
    this.getNowDate();
    this.genZiwei();
  },

  getNowDate: function () {
    var Today = new Date();
    var h = Today.getHours();
    Today.setDate(Today.getDate() + (h >= 23 ? 1 : 0));
    document.getElementById("sel_Year").value = Today.getFullYear();
    document.getElementById("sel_Month").value = Today.getMonth() + 1;
    document.getElementById("sel_Day").value = Today.getDate();
    document.getElementById("sel_Hour").value =
      EarthlyBranches[(h + (h % 2 ? 1 : 0)) % 24 / 2];
  },

  // initial
  initial: function () {
    // 畫紫微斗數空表格（新版扁平 12 宮順序）
    document.getElementById("container").innerHTML =
      "<div class='zwDivHeader'><h2>紫微斗數命盤 </h2><div>西元<select id='sel_Year'></select> 年<select id='sel_Month'></select> 月<select id='sel_Day'></select> 日<select id='sel_Hour'></select> 時<input type='radio' id='gender' name='gender' value='M' checked>男<input type='radio' name='gender' value='F'>女<input type='button' value='現在時間*' id='btnNowDate'></div></div>" +
      "<div class='ziwei'>" +
      "<div id='zw6'></div><div id='zw7'></div><div id='zw8'></div><div id='zw9'></div>" +
      "<div id='zw5'></div><div id='zwHome' class='zwDivCenter'></div><div id='zw10'></div>" +
      "<div id='zw4'></div><div id='zw11'></div><div id='zw3'></div><div id='zw2'></div><div id='zw1'></div><div id='zw12'></div>" +
      "</div>";

    function addOption(id, a, b) {
      for (i = a; i <= b; i++) {
        let op = document.createElement("option");
        op.value = i;
        op.innerHTML = i;
        document.getElementById(id).appendChild(op);
      }
    }

    addOption("sel_Year", 1900, 2049);
    addOption("sel_Month", 1, 12);
    addOption("sel_Day", 1, 31);

    for (i = 0; i < EarthlyBranches.length; i++) {
      let op = document.createElement("option");
      op.value = EarthlyBranches[i];
      op.innerHTML =
        EarthlyBranches[i] +
        "【" +
        ((24 + (i * 2 - 1)) % 24).toString() +
        "~" +
        (i * 2 + 1).toString() +
        "】";
      document.getElementById("sel_Hour").appendChild(op);
    }

    // 初始日期
    this.genNowDateZiwei();
    this.resize();
  },

  clearPalce: function () {
    for (i = 0; i < 12; i++) {
      document.getElementById("zw" + (i + 1).toString()).innerHTML =
        "<div class='MangA'>" + EarthlyBranches[i] + "</div>";
    }
  },

  cleanZiwei: function () {
    document.getElementById("zwHome").innerHTML = "";
    this.clearPalce();
  },

  genZiwei: function () {
    // 讀性別
    let gender = document.querySelectorAll("input[type=radio]");
    let genderValue = "M";
    for (i = 0; i < gender.length; i++) {
      if (gender[i].checked) {
        genderValue = gender[i].value;
        break;
      }
    }

    // 計算命盤
    var zw = ziwei.computeZiWei(
      document.getElementById("sel_Year").value,
      document.getElementById("sel_Month").value,
      document.getElementById("sel_Day").value,
      document.getElementById("sel_Hour").value,
      genderValue
    );

    // 中央資訊
    document.getElementById("zwHome").style.textAlign = "center"; // 確保父容器文字置中
    document.getElementById("zwHome").innerHTML =
      "國曆：" +
      ziwei.getSolarDay() +
      "<br>" +
      "農曆：" +
      ziwei.getLunarDay() +
      "<br>" +
      "生肖：【" +
      ziwei.getShengXiao() +
      "】" +
      "<br>" +
      // 為內層 div 加入樣式，確保它們也遵守置中規則
      "<div style='text-align: center;'>" +
      ziwei.getFiveElement() +
      "</div>" +
      "<div style='text-align: center;'>" +
      ziwei.getYinYangGender() +
      "</div>";
      
  
    // 左右方向（保留原行為）
    var styleLR = [" zwStarLeft", " zwStarRight"];
    if (this.right2left) {
      styleLR.reverse();
    }

    // ---------- Helpers ----------
    function trimFW(str) {
      // 去除半形/全形空白（含全形空格）
      return (str || "").replace(/^[\s\u3000]+|[\s\u3000]+$/g, "");
    }

    // 解析「星名 + 可選四化」：支援「紫微化科 / 紫微 科 / ZiWei 化科 / ZiWei科」
    function parseStarAndMark(s) {
      const raw = trimFW((s || "").replace(/\u3000/g, " "));
      // 末尾擷取 (化?)(祿|權|科|忌)，其餘視為星名
      const m = raw.match(/\s*(.*?)(?:\s*(?:化)?(祿|權|科|忌))?\s*$/);
      if (!m) return { name: raw, mark: "" };
      return { name: trimFW(m[1]), mark: (m[2] || "").trim() };
    }

    // 四化顯示字（想保留中文就把下面值改成 "祿/權/科/忌"）
    const MARK_MAP = { "祿":"祿", "權":"權", "科":"科", "忌":"忌" };

    // StarA/Star6：顯示完整名稱 +（若有）四化
    function fmtStarNameWithMark(s) {
      const { name, mark } = parseStarAndMark(s);
      const m = MARK_MAP[mark] || "";
      return m ? `${name} <span style="color:#8000FF">${m}</span>` : name;
    }

    // StarB / StarC：顯示完整名稱（不再截兩字）
    function fmtFull(s) {
      return trimFW((s || "").replace(/\u3000/g, " "));
    }


    // 分隔符（想讓每個項目獨立一行可改成 "<br>"）
    var SEP = "<br>";

    // ---------- 逐宮渲染 ----------
    for (i = 0; i < 12; i++) {
      var cellId = "zw" + (i + 1).toString();

      // 先放地支/宮名等（維持原本）
      document.getElementById(cellId).innerHTML +=
        "<div class='MangA'>" +
        zw[i].MangA +
        "</div>" +
        "<div class='MangB'>" +
        zw[i].MangB +
        "</div>" +
        "<div class='MangC'>" +
        zw[i].MangC +
        "</div>" +
        "<div class='StarAll'>" +
        zw[i].StarAll +
        "</div>";

      // ★ 建立「水平單行」文字
      var starAText = []
        .concat(zw[i].StarA.map(fmtStarNameWithMark))
        .concat(zw[i].Star6.map(fmtStarNameWithMark))
        .join(SEP);

      var starBText = zw[i].StarB.map(fmtFull).join(SEP);
      var starCText = zw[i].StarC.map(fmtFull).join(SEP);

      // 寫回到 DOM：StarA/StarB 依左右位置加 class，StarC 為中右
      document.getElementById(cellId).innerHTML +=
        "<div class='StarA" +
        styleLR[0] +
        "'>" +
        starAText +
        "</div>" +
        "<div class='StarB" +
        styleLR[1] +
        "'>" +
        starBText +
        "</div>" +
        "<div class='StarC'>" +
        starCText +
        "</div>";
    }

      // 大小限表
    var DS_Shian = ziwei.getDaShian();
    for (i = 0; i < 12; i++) {
      document.getElementById("zw" + (i + 1).toString()).innerHTML +=
        "<div class='MangY10'>" +
        DS_Shian.DShian[i + 1] +
        "</div>" +
        "<div class='MangY1'>" +
        DS_Shian.SShian[i + 1] +
        "</div>";
    }

        // ✅ 在這裡加「發事件」的部分 ↓↓↓
        try {
      const chartData = {};

      const PALACE_NAME_MAP = {
        // 保持原有的英文对应
        "Life":"Life","Siblings":"Siblings","Spouse":"Spouse","Children":"Children",
        "Wealth":"Wealth","Health":"Health","Mobility":"Mobility","Friends":"Friends",
        "Career":"Career","Estate":"Estate","Fortune":"Fortune","Parents":"Parents",
        
        // 繁体映射 (兼容旧数据)
        "命宮":"Life","兄弟宮":"Siblings","夫妻宮":"Spouse","子女宮":"Children","財帛宮":"Wealth",
        "疾厄宮":"Health","遷移宮":"Mobility","僕役宮":"Friends","交友宮":"Friends","官祿宮":"Career","田宅宮":"Estate",
        "福德宮":"Fortune","父母宮":"Parents",

        // 简体映射 (新增，确保简体 UI 正常运作)
        "命宫":"Life","兄弟宫":"Siblings","夫妻宫":"Spouse","子女宫":"Children","财帛宫":"Wealth",
        "疾厄宫":"Health","迁移宫":"Mobility","仆役宫":"Friends","交友宫":"Friends","官禄宫":"Career","田宅宫":"Estate",
        "福德宫":"Fortune","父母宫":"Parents"
      };

      for (let i = 0; i < zw.length; i++) {
        const cell = zw[i];

        // ① 宮名 → 統一 key
        let palaceName = (cell.MangB || "").trim().replace(/[【】()\[\]：:\s]+/g, "");
        const palaceKey = PALACE_NAME_MAP[palaceName] || `Palace_${i + 1}`;

        // ② 解析星名與四化
        const rawLists = []
          .concat(cell.StarA || [])
          .concat(cell.Star6 || [])
          .concat(cell.StarB || [])
          .concat(cell.StarC || []);

        const stars = [];
        const marks = [];
        const starMarks = []; // [{star:'ZiWei', mark:'Ke'}, ...]

        rawLists.forEach(s => {
          const { name, mark } = parseStarAndMark(s); // 你檔案上方已定義
          const cleanName = (name || "").trim();
          if (cleanName) stars.push(cleanName);

          if (mark) {
            // MARK_MAP: {"祿":"Lu","權":"Quan","科":"Ke","忌":"Ji"}（已在檔案上方）
            const mk = MARK_MAP[mark] || mark;
            marks.push(mk);
            if (cleanName) starMarks.push({ star: cleanName, mark: mk });
          }
        });

        // 去重
        const uniq = arr => Array.from(new Set(arr));

        chartData[palaceKey] = {
          stars: uniq(stars),
          marks: uniq(marks),
          starMarks: starMarks
        };
      }

      window.chartData = chartData;

      window.dispatchEvent(new CustomEvent("ziwei:chart-updated", { detail: { chartData } }));
    } catch (e) {
      console.warn("ZiWei event dispatch failed:", e);
    }
  },
};

window.addEventListener("load", function () {
  // 開始使用
  ziweiUI.initial();
  document
    .getElementById("btnNowDate")
    .addEventListener("click", function () {
      ziweiUI.genNowDateZiwei();
    });
  let s = document.querySelectorAll("select");
  for (i = 0; i < s.length; i++) {
    s[i].addEventListener("change", function () {
      ziweiUI.genZiwei();
    });
  }
  let r = document.querySelectorAll("input[type=radio]");
  for (i = 0; i < r.length; i++) {
    r[i].addEventListener("change", function () {
      ziweiUI.genZiwei();
    });
  }
  window.addEventListener("resize", function () {
    ziweiUI.resize();
  });
  // $(window).resize(function() { ziweiUI.resize();});
});
